import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/insert-management/link/index.html';

const links: Record<string, string> = {
  home: '/infoTrac/insert-management',
};

function InsertManagementLink() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const home = iframeDocument.getElementsByClassName('home');

      if (home.length) {
        for (let i = 0; i < home.length; i++) {
          home[i].addEventListener('click', () => navigate(links.home));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="insert-management-link" src={path} width="100%" height="700px" />;
}

export default InsertManagementLink;
